export default "__VITE_ASSET__ClVjRJu6__"